import clickIcon from '../../components/atomic/icons/click_icon.png';
import './LevelCountdownOverlay.css';

type LevelCountdownOverlayProps = {
  label: string;
};

export function LevelCountdownOverlay({ label }: LevelCountdownOverlayProps) {
  return (
    <div className="level-countdown-overlay" aria-live="polite">
      <div className="level-countdown-overlay__content">
        <span key={label} className="level-countdown-overlay__label">
          {label}
        </span>
        <img
          key={`click-${label}`}
          className="level-countdown-overlay__click-icon"
          src={clickIcon}
          alt=""
          aria-hidden
        />
      </div>
    </div>
  );
}
